"use client"

import type React from "react"
import { useParams, useNavigate } from "react-router-dom"
import { Container, Row, Col } from "reactstrap"
import Breadcrumbs from "../../../CommonElements/Breadcrumbs/Breadcrumbs"
import UserRoleManagement from "./user-role-management"

const UserRoleManagementContainer: React.FC = () => {
  const { userId } = useParams<{ userId: string }>()
  const navigate = useNavigate()

  const handleNavigateBack = () => {
    navigate(-1) // Go back to previous page (person detail)
  }

  // If no userId in URL, show error
  if (!userId) {
    return (
      <>
        <Breadcrumbs mainTitle="User Role Management" parent="Person Management" />
        <Container fluid>
          <Row>
            <Col md="12">
              <div className="alert alert-danger">
                <h4>No User Specified</h4>
                <p>Please select a user to manage roles.</p>
                <button className="btn btn-outline-danger btn-sm" onClick={handleNavigateBack}>
                  Back to Person List
                </button>
              </div>
            </Col>
          </Row>
        </Container>
      </>
    )
  }

  return (
    <>
      <Breadcrumbs
        mainTitle="User Role Management"
        parent="Person Management"
       
      />
      <Container fluid>
        <Row>
          <Col md="12">
            <UserRoleManagement userId={Number.parseInt(userId)} onNavigateBack={handleNavigateBack} />
          </Col>
        </Row>
      </Container>
    </>
  )
}

export default UserRoleManagementContainer
